export default __webpack_public_path__ + "static/media/Gloria-Regular.3257b31a.ttf";